import { resolvePlaceholders } from '../../../../../utils/queryParams/placeholder';
import type { GoogleAdsConversion } from '../../../../../utils/conversion/types';
import type { GoogleAdsTrackingConfig } from './types';

interface Args {
  config?: GoogleAdsTrackingConfig;
  /** The tenant's `AW-XXXXXXXXXX`, from the site config. */
  googleAdsId?: string;
  values: Record<string, string>;
}

interface ResolveValueArgs {
  template?: string;
  values: Record<string, string>;
}

/** A value that is not a number would be rejected by Google Ads - drop it. */
function resolveValue({
  template,
  values,
}: ResolveValueArgs): number | undefined {
  if (!template) return undefined;

  const resolved = resolvePlaceholders({ template, values }).trim();
  if (!resolved) return undefined;

  const value = Number(resolved.replace(',', '.'));
  return Number.isFinite(value) ? value : undefined;
}

export function buildGoogleAdsConversion({
  config,
  googleAdsId,
  values,
}: Args): GoogleAdsConversion | undefined {
  if (!config?.enabled || !config.conversionLabel || !googleAdsId) {
    return undefined;
  }

  return {
    sendTo: `${googleAdsId.trim()}/${config.conversionLabel.trim()}`,
    value: resolveValue({ template: config.value, values }),
    currency: config.currency?.trim().toUpperCase() || undefined,
  };
}
